import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import resourcesToBackend from 'i18next-resources-to-backend'

// Statically bundle the English bundle so t() returns real strings synchronously during SSR
// (no Suspense "Loading…" fallback, no raw translation keys reaching crawlers). Other locales
// still load on demand via resourcesToBackend below.
import enTranslation from './locales/en/translation.json'

const languageDetector = new LanguageDetector()

i18n
  .use(
    resourcesToBackend(
      (language, _namespace) =>
        import(`./locales/${language}/translation.json`),
    ),
  )
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    // Deterministic initial language = 'en', which is what the server renders (no browser
    // detector runs on the server). An explicit `lng` short-circuits the detector's INITIAL
    // detection, so the first client render also starts at English and hydration matches.
    // The real language is then detected + applied AFTER mount in I18nClientProvider. The
    // detector stays registered below so it still CACHES the language on every change
    // (switcher persistence via localStorage/cookie is unaffected).
    lng: 'en',
    fallbackLng: 'en',
    // English is bundled inline (available on the server); other languages are loaded
    // lazily by resourcesToBackend, so keep partialBundledLanguages on.
    resources: { en: { translation: enTranslation } },
    partialBundledLanguages: true,
    // useSuspense:false → t() never suspends; it returns the resolved string (falling back to
    // the bundled English) instead of throwing to a Suspense boundary. Essential for SSR.
    react: {
      useSuspense: false,
    },
    detection: {
      order: [
        'queryString',
        'cookie',
        'localStorage',
        'sessionStorage',
        'navigator',
        'htmlTag',
        'path',
        'subdomain',
      ],
      caches: ['localStorage', 'cookie'],
    },
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: './locales/{{lng}}/translation.json',
    },
  })

export default i18n
